import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import InputField from "./InputField";
import { useFormFormatContext } from "../UI/FormFormat/FormFormat";
const TextField = ({ name, label, required, disabled, helpText, maxLength, pattern, charCounter, append, }) => {
    const { inline } = useFormFormatContext();
    return (_jsx(InputField, { name: name, label: inline ? null : label, required: required, placeholder: inline ? label : null, className: classNames({ "mr-2": inline }), type: "text", autocomplete: "off", disabled: disabled, helpText: helpText, maxLength: maxLength, pattern: pattern, charCounter: charCounter, append: append }));
};
export default TextField;
